import { testimonials } from '@/mocks/testimonials';

export default function TestimonialsSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="font-label text-xs md:text-sm uppercase tracking-[0.2em] text-accent-600">
              User Reviews
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-[1.15]">
            Trusted by Thousands
          </h2>
          <p className="font-body text-base text-foreground-500 mt-4 max-w-lg mx-auto">
            Real feedback from real shoppers who use the Superbuy Spreadsheet every day.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-6 md:p-7 border border-background-200/60"
            >
              {/* Stars */}
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, si) => (
                  <i
                    key={si}
                    className={`text-sm ${
                      si < t.rating
                        ? 'ri-star-fill text-accent-500'
                        : 'ri-star-line text-foreground-300'
                    }`}
                  ></i>
                ))}
              </div>

              {/* Title */}
              <h4 className="font-heading text-base font-semibold text-foreground-950 mb-2">
                {t.title}
              </h4>

              {/* Content */}
              <p className="font-body text-sm text-foreground-600 leading-relaxed mb-5">
                {t.content}
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/60">
                <img
                  src={t.avatarUrl}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <p className="font-label text-sm font-semibold text-foreground-900">
                    {t.name}
                  </p>
                  <p className="font-body text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}